import { FC, ReactNode } from 'react';
import DotsSVG from 'src/shared/assets/svg/dots_in_circle.svg';
import { Tooltip } from '../Tooltip';
import s from './InfoTooltip.module.scss';

interface Props {
	info: string | string[];
	Icon?: ReactNode;
	withDEIlink?: boolean;
}
/**
 * Create a round icon with 'i' value.
 * @param props info - string or list of strings which is shown as a list
 * @param props Icon - icon which is shown instead of default icon
 * @param props withDEIlink - if true, find number in text and create a link to that page
 * @returns component
 */
export const InfoTooltip: FC<Props> = (props) => {
	const { info, Icon, withDEIlink = false } = props;

	function findNumbersInText(text: string): string[] {
		return text.match(/\b\d+\b/g) || []; // g stands for global, \b is for a number boundary
	}

	function generateLinks(text: string, numbers: string[]): JSX.Element {
		const parts = text.split(/\b(\d+)\b/);

		return (
			<span>
				{parts.map((part, index) =>
					numbers.includes(part) ? (
						<a
							key={index}
							href={`/dashboard/${part}/0`}
							target="_blank"
							rel="noreferrer"
							style={{ color: 'lightblue', textDecoration: 'underline' }}
						>
							{part}
						</a>
					) : (
						<span key={index}>{part}</span>
					),
				)}
			</span>
		);
	}

	const title =
		typeof info === 'string' ? (
			(() => {
				const numbers = findNumbersInText(info);
				return withDEIlink && numbers.length > 0 ? generateLinks(info, numbers) : <span>{info}</span>;
			})()
		) : (
			<ul>
				{info.map((item) => (
					<li key={item}>{item}</li>
				))}
			</ul>
		);

	// * Render
	return <Tooltip title={title}>{Icon ? Icon : <DotsSVG className={s.icon} />}</Tooltip>;
};
